import NSInfoBanner from 'components/NSInfoBanner/NSInfoBanner';
import { formatDate } from 'views/ProFormaTable/helpers/excelExport/helpers';
import ConstructionEndVsSaleDate from './ConstructionEndVsSaleDate';

export interface IConstructionEndsAfterSaleWarningProps {
    constructionEndDate: string | null | undefined;
    lastSaleDate: string | null | undefined;
}

const ConstructionEndsAfterSaleWarning = ({
    constructionEndDate,
    lastSaleDate,
}: IConstructionEndsAfterSaleWarningProps) => {
    const formattedConstructionEnd = constructionEndDate ? formatDate(constructionEndDate.slice(0, 10), true) : 'N/A';
    const formattedLastSale = lastSaleDate ? formatDate(lastSaleDate.slice(0, 10), true) : 'N/A';

    return (
        <NSInfoBanner
            title="Warning: Construction schedule extends past final land sale"
            subtitle="One or more construction budget lines end after the last lot sale closes. Adjust the construction 
                        timeline to finish before the final sale, or adjust the sales schedule to cover the full construction period."
            customInfo={(
                <ConstructionEndVsSaleDate
                    constructionEnd={formattedConstructionEnd}
                    lastSale={formattedLastSale}
                />
            )}
            className="mt-3 NSCard--level-4 NSCard__left-border--warning bg-warning-lighten mb-3 py-2"
            warning
            boldTitle
        />
    );
};

export default ConstructionEndsAfterSaleWarning;
